<template>
  <div>
    <b-button class="btn-detalhes"
              @click="showModal">
      Ver detalhes
    </b-button>

    <b-modal :id="`${propPedidos.cx_pedido_id}`"
             title="Detalhes O.S"
             size="xl"
             centered
             header-bg-variant="secondary"
             header-text-variant="white"
             hide-footer>
      <table class="table table-borderless">
        <thead>
          <tr>
            <th>OS</th>
            <th>Data</th>
            <th>Nome</th>
            <th>Selo</th>
            <th>Valor</th>
            <th>Status</th>
            <th>Forma de pagamento</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {{ propPedidos.ordemServico.numero }}
            </td>
            <td>
              {{ propPedidos.data_lancamento | date }}
            </td>
            <td>
              {{ propPedidos.solicitante }}
            </td>
            <td>
              <TableSelo v-if="propPedidos.ordemServico"
                         :prop-selo="propPedidos.ordemServico.itens[0] ?
                           propPedidos.ordemServico.itens[0].seloItemOs[0] : null" />
            </td>
            <td class="valor">
              <input v-money="money"
                     :value="propPedidos.ordemServico.valor_total"
                     disabled>
            </td>
            <td>
              {{ propPedidos.status_pg[0].toUpperCase() + propPedidos.status_pg.substring(1) }}
            </td>
            <td>
              <span :id="`recebimento-avulso-tooltip${propPedidos.cx_pedido_id}`">
                {{ propPedidos.parcelas.length > 1 ? 'Diversas' : propPedidos.parcelas[0].forma_pg }}
                <b-badge v-if="propPedidos.parcelas.length > 1"
                         variant="light">
                  {{ propPedidos.parcelas.length }}
                </b-badge>
                <icon-svg v-show="propPedidos.parcelas.length > 1"
                          icon="helpCircle"
                          class="icon--sm icon ml-2"
                          style="fill: #074f7f !important;" />
              </span>
              <b-tooltip v-if="propPedidos.parcelas.length > 1"
                         :target="`recebimento-avulso-tooltip${propPedidos.cx_pedido_id}`"
                         triggers="hover">
                <div v-for="(parcela, index) in propPedidos.parcelas"
                     :key="index">
                  <div class="d-flex justify-content-between tooltip-formas-pg">
                    <span>{{ parcela.forma_pg }}</span>
                    <span>{{ parcela.valor }}</span>
                  </div>                  
                </div>
              </b-tooltip>
            </td>
          </tr>
        </tbody>
      </table>
      <footer class="d-flex justify-content-between">
        <button class="btn btn-danger"
                @click="excluirPagamentos">
          Excluir pagamento realizado
        </button>
        <div class="d-flex">
          <button type="button"
                  class="btn btn-close-modal mr-3"
                  @click="hideModal">
            Voltar
          </button>
          <EditarPagamento :prop-pedido="propPedidos"
                           :prop-btn-title="'Editar dados de pagamento'"
                           @atualizarTabela="atualizarTabela" />
        </div>
      </footer>
    </b-modal>
  </div>
</template>

<script>
  // Components
  import TableSelo from '../../../FrenteDeCaixaPendentes/TableSelo.vue'
  import EditarPagamento from '../../../FrenteDeCaixaPendentes/EditarPagamento.vue'

  //Importes
  import { VMoney } from 'v-money'

  // Services
  import pagamentoService from '../../../pagamentoService'


  export default {
    name: 'DetalhesPagamento',
    directives: {
      money: VMoney
    },
    components: {
      TableSelo,
      EditarPagamento
    },
    props: {
      propPedidos: {type: Object, default: null}
    },
    data () {
      return {
        // Utilizamos nos campos de valores
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
      }
    },
    methods: {
      showModal () {
        this.$bvModal.show(`${this.propPedidos.cx_pedido_id}`)
      },
      hideModal () {
        this.$bvModal.hide(`${this.propPedidos.cx_pedido_id}`)
      },
      async excluirPagamentos () {
        try {
          loader({text: 'excluindo pagamento', active: true})

          await pagamentoService.deletePagamento(this.propPedidos.cx_pedido_id)
          this.atualizarTabela()
          this.hideModal()

          displayMessage('success', 'Pagamento excluido com sucesso')

        } catch (error) {
          const message = getErrors(error)
          console.log('DetalhesPagamento', message)

        } finally {
          loader({active: false, text: null})
        }        
      },
      atualizarTabela () {
        this.$emit('atualizarTabela')
      }
    }
  }
</script>

<style lang="scss" scoped>
.btn-detalhes {
  background-color: #C6C6C6;
  border-color: #C6C6C6;
  color: black;
}
th {
  font-weight: 400;
}
td {
  font-weight: bold;
  input {
    font-weight: bold;
    max-width: 100px;
  }
}
footer {
  padding-top: 1.2rem;
  border-top: 1px solid #074F7F;
}
.tooltip-formas-pg {
  min-width: 150px;
}
.icon {
      width: 20px;
}
</style>